const Swal = {
  fire: function({ icon, title = '', text = '', customClass = {} }) {
    const popup = document.createElement('div');
    popup.className = 'swal2-popup ' + (customClass.popup || '');
    popup.style.position = 'fixed';
    popup.style.top = '50%';
    popup.style.left = '50%';
    popup.style.transform = 'translate(-50%, -50%)';
    popup.style.backgroundColor = '#fff';
    popup.style.padding = '1.5rem';
    popup.style.borderRadius = '0.5rem';
    popup.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)';
    popup.style.zIndex = 2147483001;
    popup.style.fontFamily = 'sans-serif';
    popup.style.textAlign = 'center';
    popup.style.minWidth = '350px';
    popup.style.maxWidth = '600px';
    popup.style.wordWrap = 'break-word';
    popup.style.lineHeight = '1.4';

    let iconEl;
    if (icon) {
      iconEl = document.createElement('div');
      iconEl.textContent = icon === 'warning' ? '⚠️' : icon === 'error' ? '❌' : '';
      iconEl.style.fontSize = '2rem';
      iconEl.style.marginBottom = '0.5rem';
      if (icon === 'error') iconEl.style.cursor = 'pointer';
      popup.appendChild(iconEl);
    }

    if (title) {
      const titleEl = document.createElement('div');
      titleEl.className = customClass.title || '';
      titleEl.textContent = title;
      titleEl.style.fontWeight = '700';
      titleEl.style.fontSize = '1.5rem';
      titleEl.style.marginBottom = '0.5rem';
      popup.appendChild(titleEl);
    }

    if (text) {
      const textEl = document.createElement('div');
      textEl.className = customClass.htmlContainer || '';
      textEl.textContent = text;
      textEl.style.fontSize = '1.5rem';
      textEl.style.fontWeight = '500';
      textEl.style.marginTop = '0.5rem';
      textEl.style.color = '#000';
      textEl.style.lineHeight = '1.5';
      textEl.style.wordBreak = 'break-word';
      popup.appendChild(textEl);
    }

    document.body.appendChild(popup);

    const timeoutId = setTimeout(() => {
      if (popup.parentNode) document.body.removeChild(popup);
    }, 10000);

    if (iconEl && icon === 'error') {
      iconEl.addEventListener('click', () => {
        clearTimeout(timeoutId);
        if (popup.parentNode) document.body.removeChild(popup);
      });
    }
  }
};

document.addEventListener('DOMContentLoaded', function () {
  const logoContainer = document.getElementById('openPdf');
  const spinner = logoContainer.querySelector('.spinner-border');
  const modal = document.getElementById('ccs-modal');
  const contenedorPDF = document.getElementById('contenedorPDF');
  const canvas = document.getElementById('pdf-render');
  const btnCerrar = document.getElementById('ccs-cerrar');
  const btnDescargar = document.getElementById('btnDescargarPDF');
  const tituloCertificado = document.getElementById('titulo-certificado');
  let tooltipEl;
  let pdfBlobUrl = null;

  /*
   * IMPORTANTE:
   * El modal CCS puede venir renderizado dentro de una sección/elemento del theme
   * que crea su propio stacking context (por transform, isolation, overflow, etc.).
   * En ese escenario, aunque #ccs-modal tenga un z-index enorme, queda atrapado
   * dentro de ese contexto y otras secciones pueden dibujarse por encima.
   *
   * Lo movemos directamente a <body> para convertirlo en una capa global real.
   */
  function asegurarModalEnBody() {
    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
  }

  asegurarModalEnBody();

  btnCerrar.addEventListener('click', function () {
    modal.style.display = 'none';
    contenedorPDF.style.display = 'none';
    if (tituloCertificado) tituloCertificado.style.display = 'none';
    if (btnDescargar) btnDescargar.style.display = 'none';
  });

  modal.addEventListener('click', function (e) {
    if (e.target === modal) {
      modal.style.display = 'none';
      contenedorPDF.style.display = 'none';
      if (tituloCertificado) tituloCertificado.style.display = 'none';
      if (btnDescargar) btnDescargar.style.display = 'none';
    }
  });

  if (btnDescargar) {
    btnDescargar.addEventListener('click', function () {
      if (pdfBlobUrl) {
        const a = document.createElement('a');
        a.href = pdfBlobUrl;
        a.download = 'certificado_ccs.pdf';
        a.click();
      }
    });
  }

  function crearTooltip(text) {
    const tip = document.createElement('div');
    tip.className = 'custom-tooltip';

    const inner = document.createElement('div');
    inner.className = 'custom-tooltip-inner';
    inner.textContent = text;

    tip.appendChild(inner);
    document.body.appendChild(tip);

    return tip;
  }

  function posicionarTooltip() {
    if (!tooltipEl) return;

    const rect = logoContainer.getBoundingClientRect();
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop;

    const scrollLeft =
      window.pageXOffset ||
      document.documentElement.scrollLeft;

    tooltipEl.style.top =
      (
        rect.top +
        scrollTop +
        rect.height / 2 -
        tooltipEl.offsetHeight / 2
      ) + 'px';

    tooltipEl.style.left =
      (
        rect.left +
        scrollLeft +
        rect.width +
        10
      ) + 'px';
  }

  function mostrarTooltip() {
    if (!tooltipEl) {
      tooltipEl = crearTooltip(
        logoContainer.getAttribute('data-tooltip')
      );
    }

    posicionarTooltip();

    tooltipEl.style.opacity = 0.9;

    clearTimeout(tooltipEl.timeout);

    tooltipEl.timeout =
      setTimeout(ocultarTooltip, 30000);
  }

  function ocultarTooltip() {
    if (tooltipEl) {
      tooltipEl.style.opacity = 0;

      tooltipEl.timeout = setTimeout(() => {
        if (tooltipEl && tooltipEl.parentNode) {
          document.body.removeChild(tooltipEl);
          tooltipEl = null;
        }
      }, 200);
    }
  }

  logoContainer.addEventListener(
    'mouseenter',
    mostrarTooltip
  );

  logoContainer.addEventListener(
    'mouseleave',
    ocultarTooltip
  );

  logoContainer.addEventListener(
    'touchstart',
    mostrarTooltip
  );

  logoContainer.addEventListener(
    'touchend',
    ocultarTooltip
  );

  window.addEventListener(
    'scroll',
    posicionarTooltip
  );

  window.addEventListener(
    'resize',
    posicionarTooltip
  );

  async function abrirPdf() {

    /*
     * Reasegura que el modal siga siendo hijo directo de <body>.
     * Esto también cubre escenarios donde Shopify vuelve a
     * renderizar/mover nodos desde el editor del theme.
     */
    asegurarModalEnBody();

    contenedorPDF.style.display = 'none';

    if (tituloCertificado) {
      tituloCertificado.style.display = 'none';
    }

    if (btnDescargar) {
      btnDescargar.style.display = 'none';
    }

    if (spinner) {
      spinner.style.display = 'flex';
    }

    const ctx = canvas.getContext('2d');
    const pdfUrl = 'https://sello.ccs.cl/api/Sello';

    try {
      const resp = await fetch(pdfUrl);

      const contentType =
        resp.headers.get('content-type');

      if (
        contentType &&
        contentType.includes('application/json')
      ) {
        const data = await resp.json();

        if (data.errorCode === 'ERROR') {
          throw new Error(data.message);
        }
      }

      if (!resp.ok) {
        throw new Error(
          'La aplicación está fuera de servicio. Intente más tarde.'
        );
      }

      const blob = await resp.blob();

      if (pdfBlobUrl) {
        URL.revokeObjectURL(pdfBlobUrl);
      }

      pdfBlobUrl =
        URL.createObjectURL(blob);

      const pdfData =
        await blob.arrayBuffer();

      const loadingTask =
        pdfjsLib.getDocument({
          data: pdfData
        });

      const pdf =
        await loadingTask.promise;

      const page =
        await pdf.getPage(1);

      const RENDER_WIDTH = 700;

      const scale =
        RENDER_WIDTH /
        page.getViewport({ scale: 1 }).width;

      const viewport =
        page.getViewport({ scale });

      canvas.width =
        viewport.width;

      canvas.height =
        viewport.height;

      await page.render({
        canvasContext: ctx,
        viewport
      }).promise;

      modal.style.display = 'flex';

      contenedorPDF.style.display =
        'block';

      if (tituloCertificado) {
        tituloCertificado.style.display =
          'block';
      }

      if (btnDescargar) {
        btnDescargar.style.display =
          'inline-block';
      }

    } catch (error) {
      modal.style.display = 'none';

      Swal.fire({
        icon: 'error',
        text:
          error.message ||
          'En este momento, la aplicación se encuentra fuera de servicio. Intente más tarde.',
        customClass: {
          popup: 'swal2-popup-custom'
        }
      });

    } finally {
      if (spinner) {
        spinner.style.display = 'none';
      }
    }
  }

  logoContainer.addEventListener(
    'click',
    e => {
      e.preventDefault();
      abrirPdf();
    }
  );

  logoContainer.addEventListener(
    'touchstart',
    e => {
      e.preventDefault();
      abrirPdf();
    }
  );

  logoContainer.addEventListener(
    'contextmenu',
    e => e.preventDefault()
  );
});